import AxiosService from './AxiosService';

// Single reused Axios instance for all home-sections calls (avoids creating a
// new instance per request).
const instance = AxiosService.createProductsAxiosInstance();

const getHomeSections = async (
  clientCode: string,
  options?: {fresh?: boolean},
): Promise<any> => {
  const response = await instance.get('/catalog/home-sections', {
    headers: {
      'client-code': clientCode,
      ...(options?.fresh ? {fresh: '1'} : {}),
    },
    params: options?.fresh ? {fresh: 1} : undefined,
  });
  return response.data?.data ?? response.data;
};

const getCarouselProducts = async (
  clientCode: string,
  carouselId: number,
): Promise<any> => {
  const response = await instance.get(
    `/catalog/home-sections/carousels/${carouselId}`,
    {
      headers: {
        'client-code': clientCode,
      },
    },
  );
  return response.data?.data ?? response.data;
};

const getCarouselAllProducts = async (
  clientCode: string,
  carouselId: number,
  perPage: number,
  currentPage: number,
  brand?: string,
  packaging?: string,
): Promise<any> => {
  const response = await instance.get(
    `/catalog/home-sections/carousels/${carouselId}/all-products`,
    {
      headers: {
        'client-code': clientCode,
        'per-page': perPage,
        'current-page': currentPage,
        ...(brand ? {brand} : {}),
        ...(packaging ? {packaging} : {}),
      },
    },
  );
  return response.data?.data ?? response.data;
};

const getSuggestedAllProducts = async (
  clientCode: string,
  perPage: number,
  currentPage: number,
  brand?: string,
  packaging?: string,
  /** Ignora o cache do catálogo no servidor (`wantsFresh`). */
  fresh?: boolean,
): Promise<any> => {
  const response = await instance.get(
    '/catalog/home-sections/suggested/all-products',
    {
      headers: {
        'client-code': clientCode,
        'per-page': perPage,
        'current-page': currentPage,
        ...(brand ? {brand} : {}),
        ...(packaging ? {packaging} : {}),
        ...(fresh ? {fresh: '1'} : {}),
      },
    },
  );
  return response.data?.data ?? response.data;
};

export default {
  getHomeSections,
  getCarouselProducts,
  getCarouselAllProducts,
  getSuggestedAllProducts,
};
